import { useTranslation } from 'react-i18next';

type RoleBadgeProps = { role: string };

export const RoleBadge = ({ role }: RoleBadgeProps) => {
  const { t } = useTranslation();

  return (
    <span className="w-fit rounded-full bg-warning-soft px-4 py-1 text-base leading-6 font-normal text-foreground">
      {t(`roles.${role}.name`)}
    </span>
  );
};
